import { DateFormat, DateFormatParts, UserDateFormat } from '@agilox/ui-common';

/**
 * Map of user date formats to date formats for use in the datepicker
 */
export const USER_DATE_FORMATS: Record<UserDateFormat, DateFormat> = {
	[UserDateFormat.DMY_DOT]: {
		parts: [DateFormatParts.day, DateFormatParts.month, DateFormatParts.year],
		literal: '.',
	},
	[UserDateFormat.DMY_SLASH]: {
		parts: [DateFormatParts.day, DateFormatParts.month, DateFormatParts.year],
		literal: '/',
	},
	[UserDateFormat.DMY_DASH]: {
		parts: [DateFormatParts.day, DateFormatParts.month, DateFormatParts.year],
		literal: '-',
	},
	[UserDateFormat.MDY_SLASH]: {
		parts: [DateFormatParts.month, DateFormatParts.day, DateFormatParts.year],
		literal: '/',
	},
	[UserDateFormat.MDY_DASH]: {
		parts: [DateFormatParts.month, DateFormatParts.day, DateFormatParts.year],
		literal: '-',
	},
	[UserDateFormat.YMD_DATE]: {
		parts: [DateFormatParts.year, DateFormatParts.month, DateFormatParts.day],
		literal: '-',
	},
};
